import {Component, OnInit} from '@angular/core';
import {PeopleProfileService} from "../../services/people-profile/people-profile.service";
import {PermissionsService} from 'src/app/services/permissions/permissions.service';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {ActivatedRoute, Router} from '@angular/router'
import {BsModalRef} from "ngx-bootstrap/modal";


@Component({
  selector: 'app-people-profile',
  templateUrl: './people-profile.component.pug',
  styleUrls: ['./people-profile.component.scss'],
  standalone: false
})
export class PeopleProfileComponent implements OnInit {

  peopleData: any;
  id: string | null = '';
  loading = true;
  sortOptions = [
    {
      'label': $localize`Last activity`,
      'type': "number",
      'value': "last_activity"
    },
    {
      'label': $localize`Send date`,
      'type': "number",
      'value': "send_date"
    }
  ];
  page = '';
  ref_id: string = '';

  constructor(
    private peopleProfile: PeopleProfileService,
    private alertList: AlertBannerService,
    private route: ActivatedRoute,
    private permissions: PermissionsService,
    public router: Router
  ) {
    this.page = this.router.getCurrentNavigation()?.extras?.state?.from;
    this.ref_id = this.router.getCurrentNavigation()?.extras?.state?.checkId;
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id')
    const sort = {
      sort: 'last_activity',
      sort_order: 'desc'
    }
    this.peopleProfile.getProfile(this.id, sort).subscribe((data: any) => {
      this.peopleData = data.data;
      this.loading = false;
    }, error => {
    console.log(error);
    if (error.status === 403) {
      this.router.navigate(['/no-access']);
    } else {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    }
    this.loading = false;
  }
      );
  }

  onSortChange(event) {
    this.peopleData = []
    this.id = this.route.snapshot.paramMap.get('id')
    let param = new Object();
    if (event.includes('-')) {
      param['sort_order'] = 'desc'
    } else {
      param['sort_order'] = 'asc'
    }
    param['sort'] = event.replace('-', '')
    this.peopleProfile.getProfile(this.id, param).subscribe((data: any) => {
      this.peopleData = data.data;
      this.loading = false;
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.loading = false;
    });

  }
}
